import React, { Component } from 'react';
import { QueryCSContext } from './../contexts/QueryCSContext';
import './CSTagFilter.css';

class CSTagFilter extends Component {
	static contextType = QueryCSContext;

	constructor(props) {
		super(props);
		this.state = {
			filterTag: '',
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.value;

		this.setState({
			filterTag: value,
		});

		const { setFilterTag } = this.context;
		setFilterTag(value);
	}

	resetFilter(e) {
		e.preventDefault();

		this.setState({
			filterTag: '',
		});
		const { setFilterTag } = this.context;
		setFilterTag('');
	}
	render() {
		return (
			<div className="tagFilter">
				<p className="tagFilter__title">Tag</p>
				<div className="tagFilter__options">
					<label className="tagFilter__label">
						<input
							type="text"
							onChange={this.handleInputChange}
							value={this.state.filterTag}
							name="filterTag"
						/>
					</label>
					<span
						onClick={this.resetFilter}
						className="tagFilter__reset"
						href="#"
					>
						Clear Filter
					</span>
				</div>
			</div>
		);
	}
}

export default CSTagFilter;
